module.exports = __webpack_public_path__ + "img/pearch-logo-beta-green.028008ca.png";